module.exports = __webpack_public_path__ + "img/logo.beb314b1.png";